export const colors = Object.freeze({
  0: '#39418D',
  1: '#E0282C',
  2: '#EE5129',
  3: '#33A149',
  4: '#EFBC15',
  5: '#000000',
  6: '#FFFFFF',
  7: '#EDEEF8',
  8: '#BBBEDB',
  9: '#616ABD',
  10: '#33408F',
  11: '#1D2146',
  12: '#F5F5F5',
  13: '#CBCACA',
  14: '#BFBFBF',
  15: '#4C4C4C',
  16: '#1F2431',
  17: '#FCF3DE',
  18: '#EFFAED',
  19: '#3F7D58',
  20: '#2A4423',
  21: '#FAE2CC',
  22: '#FAEADD',
  23: '#F7F9FB',
  24: '#101010',
  25: '#D55050',
  26: '#CD1D1E',
  27: '#670909',
  28: '#278037',
  29: '#F79710',
  30: '#0092FF',
} as const);
